<template>
  <div class="ac-card-content">
    <div class="ac-header-container">
      <div v-if="!showRecommendation" class="ac-header">
        Contributing Risk Factors
      </div>
      <div v-else class="ac-header">
        Recommendations
      </div>
      <button
        type="button"
        class="ac-close-button"
        @click="toggleActionModal(false)"
      >
        <img
          src="@shared/assets/img/general/x-black.png"
          alt="x"
          class="ac-close"
        >
      </button>
    </div>
    <div class="ac-body-container">
      <fragment v-if="!showRecommendation">
        <div
          v-for="(rec, idx) in selectedHvac.risks"
          :key="idx"
          class="flex-row ai-c jc-s gap-16 margin-bottom-12"
        >
          <span
            :class="[
              'risk-pill',
              rec?.level?.toLowerCase() === 'low' ? 'green-pill' : '',
              rec?.level?.toLowerCase() === 'medium' ? 'yellow-pill' : '',
              rec?.level?.toLowerCase() === 'high' ? 'red-pill' : '',
            ]"
          >
            {{ rec.level?.toLowerCase() === 'medium' ? 'Med' : rec.level }}
          </span>
          <span class="sac__font-16 n60 width-50 ml-4">
            {{ rec.label }}
          </span>
          <span
            v-if="isSmacAdmin"
            class="sac__font-16 n60 flex-1 text-center"
          >
            {{ rec.score.toFixed(2) }}
          </span>
          <span
            v-if="isSmacAdmin"
            class="sac__font-16 n60 flex-1 text-center"
          >
            {{ getNumberLocale(rec.factor) }}
          </span>
        </div>
      </fragment>
      <fragment v-else>
        <div
          v-if="breakdownRiskRecommendations.length === 0"
          class="flex-row align-center just-center"
        >
          <span class="sac__font-18 med">
            No Recommendations
          </span>
        </div>
        <fragment v-else>
          <div
            v-for="(rec, idx) in breakdownRiskRecommendations"
            :key="idx"
            class="divider"
          >
            <div class="grid-column ai-c jc-s gap-16 margin-top-8">
              <span class="sac__font-16 med">
                {{ rec.title }}
              </span>
              <img
                v-if="rec.effort === 'low'"
                src="@shared/assets/img/breakdown-risk/one-$.png"
                alt="x"
                class="img-size-16"
              >
              <img
                v-else-if="rec.effort === 'medium'"
                src="@shared/assets/img/breakdown-risk/two-$.png"
                alt="x"
                class="img-size-16"
              >
              <img
                v-else-if="rec.effort === 'high'"
                src="@shared/assets/img/breakdown-risk/three-$.png"
                alt="x"
                class="img-size-16"
              >
              <img
                v-if="rec.impact === 'low'"
                src="@shared/assets/img/breakdown-risk/low-impact.png"
                alt="x"
                class="img-size-16"
              >
              <img
                v-else-if="rec.impact === 'medium'"
                src="@shared/assets/img/breakdown-risk/medium-impact.png"
                alt="x"
                class="img-size-16"
              >
              <img
                v-else-if="rec.impact === 'high'"
                src="@shared/assets/img/breakdown-risk/high-impact.png"
                alt="x"
                class="img-size-16"
              >
            </div>
            <div class="margin-top-16">
              {{ rec.body }}
            </div>
            <div class="grid-row gap-5 margin-top-16">
              <div class="sac__font-16 med">
                Recommended Action:
              </div>
              <div class="sac__font-16">
                {{ rec.recommend }}
              </div>
            </div>
          </div>
        </fragment>
      </fragment>
    </div>
    <div v-if="isSmacAdmin" class="ac-footer-container">
      <div />
      <button
        type="button"
        class="sac__button-sm bg-primary"
        @click="showRecommendation = !showRecommendation"
      >
        <span v-if="!showRecommendation">Show Recommendations</span>
        <span v-else>Show Factors</span>
      </button>
    </div>
  </div>
</template>
<script>

import customerDetailMixin from '@shared/mixins/customerDetailMixin';

export default {
  name: 'BreakdownRiskRecommendation',
  mixins: [customerDetailMixin],
  data() {
    return {
      showRecommendation: false,
    };
  },
  computed: {
    allBreakdownList() {
      return [{
        value: 'AF',
        title: 'Expired Air Filter',
        effort: 'low',
        impact: 'medium',
      }, {
        value: 'RP',
        title: 'Filter Pressures',
      }, {
        value: 'HAT',
        title: 'High Attic Temperature',
        effort: 'high',
        impact: 'low',
      }, {
        value: 'RT',
        title: 'Runtimes',
        effort: 'medium',
        impact: 'high',
      }, {
        value: 'NP',
        title: 'Nameplate Photo',
        effort: 'low',
        impact: 'medium',
      }, {
        value: 'AT',
        title: 'Tune-up',
        effort: 'medium',
        impact: 'medium',
      }, {
        value: 'UA',
        title: 'Unit Age',
        effort: 'high',
        impact: 'high',
      }, {
        value: 'HA',
        title: 'Home Age',
        effort: 'high',
        impact: 'high',
      }];
    },
    breakdownRiskRecommendations() {
      const {
        breakdownRecommend,
      } = this.selectedHvac;
      if (!breakdownRecommend) {
        return [];
      }
      const recommendations = [];
      if (breakdownRecommend.includes('AF')) {
        recommendations.push({
          title: 'Expired Air Filter',
          body: 'Regular air filter maintenance is critical for the health\n'
            + '            of your HVAC system. If air filters are left in place after\n'
            + '            they should have been changed it can cause additional system\n'
            + '            run time, increased energy expense, and increased breakdown risk.',
          recommend: 'Install a new air filter.',
          effort: 'low',
          impact: 'medium',
        });
      }
      if (breakdownRecommend.includes('HAT')) {
        recommendations.push({
          title: 'High Attic Temperature',
          body: 'High attic temperature can be an indicator of a poorly\n'
            + '            ventilated attic space. This can result in increased heat\n'
            + '            gain for the AC unit and duct system.',
          recommend: 'Consider additional attic ventilation via vents or fan ventilators.',
          effort: 'high',
          impact: 'low',
        });
      }
      if (breakdownRecommend.includes('RT')) {
        recommendations.push({
          title: 'Runtimes',
          body: 'High system run time can be an indicator of poor performance.\n'
            + '            Extremely high system run time can indicate active system issues.',
          recommend: 'Consider purchasing a smart thermostat to support setbacks and\n'
            + '            optimized scheduling. If high run time continues consider having\n'
            + '            an inspection done by a qualified HVAC professional.',
          effort: 'medium',
          impact: 'high',
        });
      }
      if (breakdownRecommend.includes('NP')) {
        recommendations.push({
          title: 'Nameplate Photo',
          body: 'The condenser nameplate photo provides useful information about\n'
            + '            the system configuration. Without the nameplate, expected system\n'
            + '            performance and associated trouble signs can not be defined.',
          recommend: 'Please follow the in-app instructions to add a photo of\n'
            + '            the nameplate on your condenser.',
          effort: 'low',
          impact: 'medium',
        });
      }
      if (breakdownRecommend.includes('AT')) {
        recommendations.push({
          title: 'Tune-up',
          body: 'An inspection by a qualified HVAC professional can ensure\n'
            + '            all your equipment is in proper working order, greatly reducing\n'
            + '            the risk of an unexpected breakdown. Parts like capacitors that\n'
            + '            are designed to wear out can be identified and repaired before\n'
            + '            they fail, ensuring comfort is maintained.',
          recommend: 'Consider having an inspection done if it`s been more than a\n'
            + '            year since your last one.',
          effort: 'medium',
          impact: 'medium',
        });
      }
      if (breakdownRecommend.includes('UA')) {
        recommendations.push({
          title: 'Unit Age',
          body: 'System age can be a good indicator of expected breakdown risk,\n'
              + '            especially as systems approach the end of the design life span.',
          effort: 'high',
          impact: 'high',
        });
      }
      if (breakdownRecommend.includes('HA')) {
        recommendations.push({
          title: 'Home Age',
          body: 'In general, Home efficiency has improved over time. Insulation value\n'
            + '            has improved, along with envelope performance (how leaky the home is).\n'
            + '            This means older houses generally require more cooling/heating energy\n'
            + '            to maintain set point.',
          effort: 'high',
          impact: 'high',
        });
      }
      return recommendations;
    },
  },
};
</script>

<style lang="scss" scoped>
.divider {
  margin-top: 1rem;
  border-top: 2px solid $N20;
  &:first-child {
    margin-top: unset;
    border-top: unset;
  }
}
.risk-pill {
  width: 52px;
  height: 20px;
  border: 1px solid;
  border-radius: 9px;
  text-align: center;
  font-size: 12px;
  font-weight: 600;
  &.green-pill {
    background-color: #E1FFE8;
    border-color: #00AB3C;
    color: #00AB3C;
  }
  &.yellow-pill {
    background-color: #FFF2D9;
    border-color: #FFAB00;
    color: #FFAB00;
  }
  &.red-pill {
    background-color: #FFEAEB;
    border-color: #EB0A0E;
    color: #EB0A0E;
  }
}
</style>
